
import axios from 'axios'
import Router from 'vue-router'
import router from '../../router/index.js'
import store from '../../store/store.js'

axios.defaults.timeout = 10000;
axios.interceptors.request.use(function (config) {
  store.state.loadding=true;
  if(sessionStorage.getItem('token')){    //如果token已经存储在本地了，代表是已经进行了登录，且登录成功
    config.headers[ 'token' ] =sessionStorage.getItem('token')     //此时将token添加到url的头部header中
  }else {
    config.headers[ 'token' ] = '1'
  }
  config.headers['Content-Type'] = 'application/json';
  //config.headers['Product']='sale_mini';//正式环境
  config.headers['Product']='admin_web';//测试环境

  config.headers['Version']='0.0.1';
  return config
}, function (error) {
  Message.error({
    message: '请求错误：' + error.message
  })
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  if(response.data.code == '401'){
    router.push({path:'login'})
    sessionStorage.removeItem("userinfo");
    sessionStorage.removeItem("token");
  }
  store.state.loadding=false;
  return response
}, function (error) {
   if(error.message == 'timeout of 5000ms exceeded'){
      return {code : 10,message:'请求超时'}
   }else{
      return {code :500, message:'网络连接失败，请稍后重试'}
   }
   store.state.loadding=false;
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/assets/js/axios.js